<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-01 19:40:29
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-08-24 10:49:06
-->
<template>
	<div>
		<el-popover placement="bottom-start" width="300" trigger="hover" v-if="showConflictTip">
			<div>
				<p><i class="el-icon-warning warning fz-14 mr-4 yx-color-text-primary"></i>存在多个{{ drName }}跟进，请手动补单确认归属</p>
				<div v-for="item in conflictOrderList" :key="item.partner_role_name" class="mt-16 ml-20 fz-14 yx-color-text-primary">
					<template>
						<p>{{ item.partner_role_name }}</p>
						<p>提成比：{{ item.rate_value }}%</p>
						<div class="mt-4">
							<span class="mr-12">预估提成：¥{{ item.partner_estimated_commission }}</span>
							<span class="pl-12 split-line">实际提成：¥{{ item.partner_real_commission }}</span>
						</div>
					</template>
				</div>
			</div>
			<p slot="reference"><i class="el-icon-warning warning fz-16"></i>多员工跟进，请手动补单</p>
		</el-popover>
		<div v-else-if="showPartner">
			<p>
				<span class="mr-4">{{ row.partner_name }}</span>
				<el-tag v-if="row.talent_info.deleted" type="danger" size="mini" effect="plain">账号已删除</el-tag>
				<el-tag v-else-if="row.talent_info.use_status === '2'" type="danger" size="mini">账号已停用</el-tag>
			</p>
			<template v-if="row.partner_rate != '--'">
				<p>提成比：{{ row.partner_rate }}%</p>
				<p>预估提成：¥{{ row.partner_commission_fee }}</p>
				<p>实际提成：¥{{ row.partner_real_commission_fee }}</p>
			</template>
			<p v-else-if="$auth.hasPermi('system:Order:Master-business-performance')">
				<span>提成比：</span>
				<el-tooltip content="未对该员工设置提成，请去【团队管理-子账号管理】进行设置">
					<span>未设置</span>
				</el-tooltip>
			</p>
		</div>
		<span v-else></span>
	</div>
</template>
<script>
import mixin from './mixin';
import { drRoleType } from '@/utils/dataMap';

export default {
	mixins: [mixin],
	computed: {
		conflictOrderList() {
			return this.row?.order_collide_list || [];
		},
		showConflictTip() {
			return !!this.conflictOrderList?.length;
		},
		showPartner() {
			return !!this.row?.partner_name;
		},
		drName() {
			return drRoleType.name;
		},
	},
};
</script>
<style lang="less" scoped>
.split-line {
	position: relative;

	&:before {
		content: '';
		position: absolute;
		left: 0px;
		top: 2px;
		width: 1px;
		height: 15px;
		background-color: #ccc;
	}
}
</style>
